/** 行事曆儀表板(index.html)進入點。 */
import '../loading';
import { initStudentPage } from '../dashboard';

void initStudentPage();
